module.exports = __webpack_public_path__ + "static/media/0-0.8777db93.svg";